import { BaseURL } from "../../config/axios";
import $ from 'jquery';
import { useCallback, useEffect, useState } from "react";
import { getLandingPaintings } from "../../api-route/painting";
import 'justifiedGallery';

import { Link, useParams } from "react-router-dom";

const debounce = (func, wait) => {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

export default function ArtSection({ initData = [], id = 0, title, url, withMore = true }) {
  const [data, setData] = useState()
  const params = useParams()


  useEffect(() => {
    if (initData.length) setData(initData)
    else {
      const get = async () => {
        const data = await getLandingPaintings()
        setData(data || [])
      }
      get()
    }
  }, [params])

  const initializeGallery = useCallback(() => {
    const isMobile = window.innerWidth < 768; // Define your mobile threshold here
    const rowHeight = isMobile ? 100 : 200;
    const margin = isMobile ? 5 : 10;

    $(`#mygallery${id}`).justifiedGallery('destroy').justifiedGallery({
      margins: margin,
      randomize: true,
      captions: true,
      rowHeight: rowHeight,
      lastRow: (!!data && data.length > 5) ? 'hide' : 'nojustify',
      cssAnimation: false,
    });
  }, [data]);

  useEffect(() => {
    if (!!data && data.length) {
      initializeGallery();

      const handleResize = debounce(initializeGallery, 100);

      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
      };
    }
  }, [data, initializeGallery]);

  return (
    <>
      {!!data && data.length &&
        <section className="container flex flex-col w-full items-center my-12 gap-6">
          <div dir="rtl" className="flex text-center flex-col gap-6">
            <h3 className="title">{title || "محبوب‌ترین آثار هنری"}</h3>
          </div>
          <div id={`mygallery${id}`} >
            {data.map((item, index) => <GalleryItem key={index} {...item} />)}
          </div>
          {withMore && <Link to={url ?? "/product?page=1"} className="bg-gray-200 rounded-lg px-4 py-2 text-md">
            نمایش همه آثار
          </Link>}
        </section>
      }
    </>
  );
}

function GalleryItem({ id, slug, title, images }) {
  return (
    <Link to={"/product/" + slug} className="group rounded relative block">
      <img
        src={BaseURL + images[0]?.path} title={title} width={100} height={100} className="w-full h-auto" alt={title} />
    </Link>
  );
}
